
export const OutStockData = [
  {
    companyName: '四川某某公司',
    stockoutCode: 'CK-12345678910231',
    unitName: '北京代理商',
    handlerName: '刘某某',
    stockoutType: '销售出库',
    warehouseName: '京东北京仓',
    businessDate: '2020-08-27 12:00:00',
    createUserName: '胡某某',
    created: '2020-08-27 12:00:00',
    remark: '备注一下',
    totalPrice: '129.00',
    receivePerson: '易某某',
    receivePhone: '18982068701',
    address: '四川省成都市武侯区 天府软件园',
    details: [
      {
        productName: '苹果ipone11pro',
        skuName: 'iphone11pro256g',
        specModel: '165L',
        quantity: 17,
        snCode: '[SPP1Y79G1]',
        price: '8999.00'
      },
      {
        productName: '苹果手机壳123',
        skuName: 'iphone11pro256g',
        specModel: '165L',
        quantity: 9,
        snCode: '[SPP1Y79G1]',
        price: '23.00'
      },
      {
        productName: '苹果ipone11pro',
        skuName: 'iphone11pro124g',
        specModel: '165L',
        quantity: 13,
        snCode: '[SPP1Y79G1]',
        price: '7099.00'
      }
    ]
  }
]
export const InStockData = [
  {
    companyName: '某某偶科技公司',
    purcheckCode: 'Rk-12345678910231',
    unitName: '四川分销商',
    purchaseSaleManName: '刘夏',
    purcheckType: '采购入库',
    warehouseName: '京东成都仓',
    businessDate: '2020-08-27 12:00:00',
    createUserName: '胡某某',
    created: '2020-08-27 12:00:00',
    remark: '备注一下',
    totalPrice: '129.00',
    details: [
      {
        productName: '苹果ipone11pro',
        skuName: 'iphone11pro256g',
        specModel: '165L',
        quantity: 3,
        snCode: '[SPP1Y79G1]',
        price: '12.00'
      },
      {
        productName: '苹果ipone11pro',
        skuName: 'iphone11pro124g',
        specModel: '165L',
        quantity: 3,
        snCode: '[SPP1Y79G1]',
        price: '12.00'
      }]
  }
]


// WEBPACK FOOTER //
// ./src/views/print/data/test.js